import React from 'react';
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Spinner } from '../../../components-core/packages/components-core/dist/spinner';

//INPUT
import { TextInput, TextInputAppearance } from '../../../components-core/packages/components-core/dist/text-input';

//CUSTOM COMPONENTS
import ResultRow from './inner-components/ResultRow';
import TitleSection from './inner-components/TitleSection';


const Border = styled.div`
    border: 1px solid #000;
`;

const Line = styled.div`
    background-color: #c2cacf;
    width: 100%;
    height: 1px;
`;


//TODO @TugkanPilka: Lütfen bekleyiniz yazısının yazmasını sağla.
class FramedQuery extends React.Component {

    renderResults() {
        const datasetLength = dummyData.length;
        const renderedRows = dummyData.map((data, index) => [
            <ResultRow />,
            index + 1 !== datasetLength ? renderLine() : undefined
        ])

        return (
            <Container 
                wrap={ContainerWrap.always}
                padding={resultsContainerPadding}
            >
                {renderedRows}
            </Container>
        )
    }

    render() {
        return (
            <Container padding={topContainerPadding} stretchContent={true}>
                <Border>
                    <Container 
                        padding={innerContainerPadding} 
                        wrap={ContainerWrap.always} 
                        gutter={ContainerGutter.dynamic0150}
                    >
                        <TitleSection />
                        <Container 
                            wrap={ContainerWrap.never} 
                            horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                        >
                            <TextInput 
                                placeholder={'Araç plakası.'}
                                appearance={TextInputAppearance.Search}
                                name="sorgula"
                                hasClearButton={true}
                                isClearButtonVisible={false}
                                onClear={() => {}}
                                onChange={() => {}}
                                ref={'textinput'}
                            />
                            <Spinner variant={'large'} />
                        </Container>
                    </Container>
                </Border>
            </Container>
        )
    }
}


const renderLine = () => (
    <Container 
        stretchContent={true} 
        padding={{ top: ContainerPadding.dynamic0100, bottom: ContainerPadding.dynamic0100 }} 
    >
        <Line />
    </Container>
)


const topContainerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004,
    }, 
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004,
    },
}

const innerContainerPadding = {
    top: { [Breakpoints.default]: ContainerPadding.dynamic0200 },
    right: { [Breakpoints.default]: ContainerPadding.dynamic0200 },
    bottom: { [Breakpoints.default]: ContainerPadding.dynamic0270 },
    left: { [Breakpoints.default]: ContainerPadding.dynamic0200 },
}

const resultsContainerPadding = {
    left: {
        [Breakpoints.default]: null,
        [Breakpoints.b960]: ContainerPadding.grid002
    },
    right: {
        [Breakpoints.default]: null,
        [Breakpoints.b960]: ContainerPadding.grid002
    }
}




const dummyData = [
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
    {
        code: 'r3535',
        status: 'Tamamlandı'
    },
] 


export default FramedQuery;